import React from "react";
import { motion } from "framer-motion";
import "../GuidedTour.css";

export default function Step4_UploadAnswer({
  onComplete,
  studentName,
  testName,
}) {
  const handleSubmit = (e) => {
    e.preventDefault();
    onComplete();
  };

  const handleViewSample = () => {
    window.open("/files/Sample_Answer_Paper.pdf", "_blank");
  };

  return (
    <div className="tour-step-container">
      <motion.div
        className="tour-step-full-card"
        initial={{ scale: 0.95 }}
        animate={{ scale: 1 }}
        transition={{ duration: 0.2 }}
      >
        {/* Step Header */}
        <div className="tour-step-header">
          <div className="tour-step-icon-large">
            <i className="fa-solid fa-cloud-arrow-up"></i>
          </div>
          <h2 className="tour-step-title">Upload Answer Paper</h2>
          <p className="tour-step-description">
            Upload the answer paper for grading with AI.
          </p>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="tour-step-form">
          {/* Sample Answer Paper */}
          <div className="upload-section demo-info-section">
            <div className="info-header">
              <i className="fa-solid fa-file-pdf"></i>
              Sample Answer Paper
            </div>
            <p className="info-description">
              For this tour, we'll use a sample answer paper to show you how AI
              grading works.
            </p>
            <div className="sample-actions">
              <button
                type="button"
                className="sample-view-btn"
                onClick={handleViewSample}
              >
                <i className="fa-solid fa-eye"></i>
                View Sample Answer
              </button>
            </div>
          </div>

          {/* Submit Button */}
          <div className="demo-form-actions">
            <button type="submit" className="demo-submit-btn">
              <i className="fa-solid fa-circle-chevron-right"></i>
              Next
            </button>
          </div>
        </form>
      </motion.div>
    </div>
  );
}
